import { Route } from '@angular/router';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    data: {
      headerTitle: 'Verificacion segura',
      pageTitle: 'Verificación segura | Diseño y Gestión',
      showHeader: false,
    },
    loadComponent: () =>
      import('./pages/home/verification-home-page.component').then(
        (m) => m.VerificationHomePageComponent,
      ),
  },
  {
    path: 'sign/file/:token',
    data: {
      headerTitle: 'Firma digital',
      pageTitle: 'Firma digital | Diseño y Gestión',
      allowFileUpload: true,
    },
    loadComponent: () =>
      import('./pages/sign/sign-landing-page.component').then(
        (m) => m.SignLandingPageComponent,
      ),
  },
  {
    path: 'sign/:token',
    data: {
      headerTitle: 'Firma digital',
      pageTitle: 'Firma digital | Diseño y Gestión',
      allowFileUpload: false,
    },
    loadComponent: () =>
      import('./pages/sign/sign-landing-page.component').then(
        (m) => m.SignLandingPageComponent,
      ),
  },
  {
    path: 'identity/file/:token',
    data: {
      headerTitle: 'Validacion de identidad',
      pageTitle: 'Validación de identidad | Diseño y Gestión',
      allowFileUpload: true,
    },
    loadComponent: () =>
      import('./pages/identity/identity-landing-page.component').then(
        (m) => m.IdentityLandingPageComponent,
      ),
  },
  {
    path: 'identity/:token',
    data: {
      headerTitle: 'Validacion de identidad',
      pageTitle: 'Validación de identidad | Diseño y Gestión',
      allowFileUpload: false,
    },
    loadComponent: () =>
      import('./pages/identity/identity-landing-page.component').then(
        (m) => m.IdentityLandingPageComponent,
      ),
  },
];
